<template>
  <v-container fluid>
    <v-select
      v-model="value"
      :items="items"
      class="mt-3"
      style="width: 60px"
      @change="changeLangCode"
      :menu-props="{
        contentClass: 'flags-menu',
      }"
    >
      <template v-slot:item="{ item, index }">
        <gb-flag :code="item" size="small" />
      </template>

      <template v-slot:selection="{ item, index }">
        <gb-flag :code="item" size="small" />
      </template>
    </v-select>
  </v-container>
</template>

<script>
import data_tsl from "@/data/country_code.js";
import tsl from "@/utils/translation.js";

export default {
  data() {
    return {
      items: tsl.getLangList(data_tsl.allowed_country),
      value: null,
    };
  },

  methods: {
    changeLangCode() {
      this.$root.$i18n.locale = tsl.buildIETFCountryLang(this.value);
    },
  },  
  mounted() {
  this.$nextTick(() => {
    this.value = tsl.getIETFCountry(this.$root.$i18n.locale);
  });
},
};
</script>

<style lang="scss" scoped></style>
<style>
.v-menu__content.flags-menu {
  z-index: 10000 !important;
}
</style>
